export default __webpack_public_path__ + "assets/models/59bec1f8ea3b02016c5f86a6904ed99d.glb";